export const MERCH_CARD = 'MERCH_CARD';
export const CALCULATOR = 'CALCULATOR';
export const INTERSTITIAL = 'PRICING_PAGE_INTERSTITIAL';